/**
 * User: herbert
 * Date: 20.10.15
 * Time: 19:22
 */

import Reflux from 'reflux';
import request from 'request';

import memoizee from 'memoizee';

import userActions from '../actions/user-actions';
import stepActions from '../../slxstep/actions/step-actions';
import optionActions from '../../stele/actions/option-actions';

//import * as stepConfig from '../../../config-steps.js';
//import * as config from '../../../config.js';


const COOKIE_NAME = 'slxcfgsession';

const parseQuery = memoizee(function parseQuery_(qstr) {
	const query = {};
	const a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
	for (let i = 0; i < a.length; i++) {
		const b = a[i].split('=');
		query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
	}
	return query;
});
export {parseQuery};

function getCookie() {
	const s = COOKIE_NAME + '=';
	const cookies = document.cookie.split(';');
	console.log(cookies);

	for (let i=0; i<cookies.length; i++) {
		let c=cookies[i];
		while (c.charAt(0) === ' ')
			c = c.substring(1, c.length);
		console.log(i, '"'+c+'"');
		if (c.indexOf(s) === 0)
			return c.substring(s.length, c.length);
	}

	const query = parseQuery(location.search);
	if (query[COOKIE_NAME]) {
		document.cookie = COOKIE_NAME + '=' + query[COOKIE_NAME] + ';path=/'; // set session cookie without explicit expire
		return query[COOKIE_NAME];
	}
	return null;
}

function deleteCookie() {
	document.cookie = COOKIE_NAME + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

export default Reflux.createStore({
	init: function() {
		this._resetState();

		const base = location.href.slice(0, location.href.lastIndexOf('/'));
		const targetBase = base.slice(0, base.lastIndexOf('/')) + '/user-management/'; // cd ../user-management
		console.log('user-management url: '+targetBase);

		this._auth = request.defaults({
			url: targetBase + 'auth.php',
			method: 'POST',
			json: true,
			callback: this._authCallback
		});
		this._cookieAuth = this._auth.defaults({
			method: 'GET'
		});
		this._deAuth = this._cookieAuth.defaults({
			url: targetBase + 'logout.php',
			callback: this._deAuthCallback
		});
		this._set = request.defaults({
			url: targetBase + 'setUserOption.php',
			method: 'POST',
			json: true,
			callback: this._setCallback
		});

		const cookie = getCookie();
		if(cookie && cookie !== '') {
			console.log('found old session: ' + cookie);
			this._lastAuth = {request:  this._cookieAuth()}; // pay attention to that really hidden call ;)
		}

		this.listenToMany(userActions);

		// we going to listen to some actions to know when to close user box, but we have to take care not to listen to the ones issued here
		this.listenToMany(stepActions);
		this.listenToMany(optionActions);
	},
	_resetState: function (visible) {
		this.state = {
			visible: !!visible,
			user: null,
			pricesAllowed: false,
			pricesRequested: false,
			token: null
		};
	},
	_authCallback: function(error, response, body) {
		console.log('v-- _authCallback');
		console.log(error);
		console.log(response ? response.statusCode : ' --no response --');
		console.log(response);
		console.log(body);
		console.log('^--');

		if (response && response.request !== this._lastAuth.request) {
			// ignore old requests
			return;
		}

		if (error || response.statusCode < 200 || response.statusCode >= 300) {
			this._resetState(true);
			deleteCookie();
			if (this._lastAuth.errorCallback) {
				this._lastAuth.errorCallback(error, response, body);
			}
		} else {
			this.state = {
				visible: !!this._lastAuth.errorCallback, // true if called from ui which sets a errorCallback , whereas the re-auth from init does not
				user: body.userName,
				pricesAllowed: body.lif_allow_price,
				pricesRequested: body.lif_allow_price && body.lif_show_price
			};
		}
		this.output();
	},
	_deAuthCallback: function(error, response, body) {
		if(this._lastAuth.deAuthRequest)
			deleteCookie();
	},
	_setCallback: function(error, response, body) {
		if (response && response.request !== this._lastSet.request)
			return;
		if (error || response.statusCode < 200 || response.statusCode >= 300) {
			console.log('_setCallback failed', error, response, body, (response?response.statusCode:'--') );
			if(response.statusCode === 401) {
				// log-out
				this._resetState(true);
				deleteCookie();
				if (this._lastSet.passwordFailCallback) {
					this._lastSet.passwordFailCallback(error, response, body);
				}
			} else {
				// ignore
			}
		} else {
			console.log('_setCallback success', error, response, body);
			// NOP, everything done already
		}
		this._lastSet = {};
		this.output();
	},
	output: function() {
		stepActions.setExtraClass({login: this.state.user ? 'slx-login--active' : null});
		this.trigger(this.getInitialState());
	},
	getInitialState: function() {
		return {
			visible: this.state.visible,
			user: this.state.user,
			pricesAllowed: this.state.pricesAllowed,
			pricesRequested: this.state.pricesRequested
		};
	},
	toggle: function() {
		this.state.visible = !this.state.visible;
		if(this.state.visible)
			optionActions.clear();
		//stepActions.setExtraClass({userbox: this.state.visible ? 'slx-user--open' : null});   // unused by now
		this.output();
	},
	close: function() {
		if(this.state.visible) {
			this.state.visible = false;
			//stepActions.setExtraClass({userbox: null});  // unused by now
			this.output();
		}
	},
	/** log a user in
	 * @param{String} name  user's name
	 * @param{String} pw    user's password
	 * @param{Function} onError a error callback function. It receives <pre>error</pre>, <pre>response</pre> and <pre>body</pre>
	 */
	login: function (name, pw, onError) {
		this._lastAuth = {
			userName: name,
			deAuthRequest: null
		};
		//const data = JSON.stringify(this._lastAuth);
		this._lastAuth.errorCallback = onError;
		this._lastAuth.request = this._auth({body: {
			userName: name,
			password: pw
		}});
		//this.output(); // erst nach login per authCallback
	},
	/** log user out
	 *
	 */
	logout: function () {
		this.state.user = null;
		this._lastAuth = {request: null};
		//	deleteCookie() in Callback
		this._lastAuth.deAuthRequest = true;
		this._deAuth();
		this.output();
	},
	showPrices: function(showPrices, passwordFailCallback) {
		this.state.pricesRequested = showPrices && this.state.pricesAllowed;
		this._lastSet = {
			passwordFailCallback: passwordFailCallback
		};
		this._lastSet.request = this._set({body: {
			optionName: 'lif_show_price',
			optionValue: showPrices
		}});
		this.output(); // mit Absicht sofort. wir ignorieren hier datanbank fehler außer logout (onPasswordFail)
	},
	// listen to some action from ohter modules to close box if open
	/** switch to next step */
	next: function() {this.close();},
	prev: function() {this.close();},
	switchStep: function() {this.close();},
	switchSubStep: function() {this.close();},
	set: function() {this.close();},
	// actions used here, we are not allowed to listen to (or have to detect ourselves)
	//setExtraClass: {}
	//clear: {}
});
